<template>
  <el-row :gutter="12">
    <el-card shadow="hover" id="works">
      <el-row class="row align-items-center">
        <el-col :span="16" :push="4">
          <h3 style="padding-top: 15px">一些作品……</h3>
        </el-col>
        <el-col :span="2" :push="4">{{showing}}</el-col>
        <el-col :span="2" :push="4">
          <el-switch v-on:change="swChange()"
                     v-model="switchVal"
                     active-color="#13ce66"
                     inactive-color="#13ce66">
          </el-switch>
        </el-col>
      </el-row>
      <hr/>
      <component :is="showing"></component>
    </el-card>
  </el-row>
</template>

<script>
import GitHub from './GitHub'
import Bilibili from './Bilibili'

export default {
  name: 'Works',
  data () {
    return {
      switchVal: true,
      showing: 'GitHub'
    }
  },
  methods: {
    swChange: function () {
      if (this.switchVal) {
        this.showing = 'GitHub'
      } else {
        this.showing = 'Bilibili'
      }
    }
  },
  components: {
    GitHub,
    Bilibili
  }
}
</script>

<style scoped>
  #works {
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Works.vue